"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Panel = _interopRequireDefault(require("./Panel"));

var _PanelWithHeaderModule = _interopRequireDefault(require("./PanelWithHeader.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PanelWithHeader = function PanelWithHeader(_ref) {
  var header = _ref.header,
      headerClassName = _ref.headerClassName,
      contentClassName = _ref.contentClassName,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["header", "headerClassName", "contentClassName", "children"]);

  return _react.default.createElement(_Panel.default, props, _react.default.createElement("div", {
    className: "".concat(headerClassName, " ").concat(_PanelWithHeaderModule.default.header)
  }, header), _react.default.createElement("div", {
    className: "".concat(contentClassName, " ").concat(_PanelWithHeaderModule.default.content)
  }, children));
};

process.env.NODE_ENV !== "production" ? PanelWithHeader.propTypes = {
  header: _propTypes.default.any.isRequired,
  children: _propTypes.default.any.isRequired,
  headerClassName: _propTypes.default.string,
  contentClassName: _propTypes.default.string
} : void 0;
PanelWithHeader.defaultProps = {
  headerClassName: '',
  contentClassName: ''
};
var _default = PanelWithHeader;
exports.default = _default;